module.exports = __webpack_public_path__ + "files/41ef8e5d0ac53654511397e6f165eb0f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300.svg
 ** module id = 942
 ** module chunks = 0
 **/